import * as React from 'react';
import {
  MasonryEngineNode,
  MasonryEngineNodeAction,
  MasonryEngineNodeRendererProps,
  useMasonryEngineActionEmitter,
} from '@leagueplatform/masonry-engine';
import { useStaticAsset } from '@leagueplatform/asset-config';
import { GDSHeadingLevel } from '@leagueplatform/genesis-core';
import { CHAT_HISTORY_MODULE_ASSET_KEYS } from '../../../asset-map';
import { MessageState } from '../../../components/message-state/message-state.component';

export const NODE_TYPE_CHAT_HISTORY_ERROR_STATE = 'chatHistoryErrorState';

type ChatHistoryErrorStateProps = {
  heading: string;
  headingLevel?: GDSHeadingLevel;
  description?: string;
  buttonLabel?: string;
  image?: {
    source: string;
    description: string;
  };
};

type ChatHistoryErrorStateActions = {
  onRetry?: MasonryEngineNodeAction;
};

type ChatHistoryErrorStateNode = MasonryEngineNode<
  typeof NODE_TYPE_CHAT_HISTORY_ERROR_STATE,
  ChatHistoryErrorStateProps,
  ChatHistoryErrorStateActions
>;

export type ChatHistoryErrorStateRendererProps =
  MasonryEngineNodeRendererProps<ChatHistoryErrorStateNode>;

export const ChatHistoryErrorStateRenderer = ({
  heading,
  headingLevel,
  description,
  buttonLabel,
  image,
  onRetry,
}: ChatHistoryErrorStateRendererProps): React.ReactElement => {
  const invokeAction = useMasonryEngineActionEmitter();
  const defaultImage = useStaticAsset(
    CHAT_HISTORY_MODULE_ASSET_KEYS.ERROR_STATE,
  ) as string;

  const handleRetry = React.useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      if (onRetry) {
        invokeAction({ event, ...onRetry });
      }
    },
    [invokeAction, onRetry],
  );

  return (
    <MessageState
      image={image?.source ?? defaultImage}
      imageAlt={image?.description ?? ''}
      heading={heading}
      headingLevel={headingLevel}
      description={description}
      buttonLabel={buttonLabel}
      onButtonClick={onRetry ? handleRetry : undefined}
    />
  );
};
